import { BaixaCobranca } from './../../../model/baixa-cobranca.model';
import { Injectable } from "@angular/core";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Observable } from "rxjs";
import { catchError, map} from "rxjs/operators";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { Aviso } from 'src/app/model/aviso.model';
import { RetornoMensagemSimplesDTO } from 'src/app/model/questionario.model';


@Injectable({
  providedIn: 'root'
})
export class TarefasCobrancaService extends FgiBackEndService<any> {

  getNewEntity() {
    return null;
  }
  protected getResourceURL(): string {
    return 'front/tarefas/cobranca';
  }

  public emitir(): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/emitir`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public baixar(dto: BaixaCobranca): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/baixar`, dto, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public simularEmissao(): Observable<RetornoMensagemSimplesDTO> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/simular-emissao/`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<RetornoMensagemSimplesDTO>;
  }

  public simularBaixa(ideCobranca: number): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/simular-baixa/${ideCobranca}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public gerarPlanilhaSCC(emailsEnvioPlanilha: string[]): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/gerar-planilha-scc/${emailsEnvioPlanilha}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public gerarContabilizacoes(emailsEnvioContabilizacoes: string[]): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/gerar-contabilizacoes/${emailsEnvioContabilizacoes}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public sincronizarVsamRcc(idSistema: number, prefixoVsam: string): Observable<any> {
    const options: any = blockUi()
    return this.http.post(`${this.BASE_URL}/sincronizar-vsam-rcc/${idSistema}/${prefixoVsam}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  sincronizarVsamRccComArquivoEnviadoPeloPortal(idSistema: number, anexo?: string): Observable<Aviso> {
    var formData =  new FormData();
    if (anexo) {
      formData.append("vsam", anexo);
    }
    const options: any = blockUi()
    return this.http.post(`${this.BASE_URL}/sincronizar-vsam-rcc/${idSistema}`,formData, options).pipe(
      map(response => this.convertToType(response)),
      catchError((e) => this.handleError(e))) as Observable<Aviso>;

  } 
}
